/**
 * This is a stub for `monaco-yaml/lib/esm/schemaSelectionHandlers.js`.
 */
// eslint-disable-next-line @typescript-eslint/no-empty-function
export function JSONSchemaSelection(): void {}
